module.exports = __webpack_public_path__ + "img/douyin.e82fa711.png";